define('views/modules/noclient/noclient',[
    'backbone', 'mustache',
    // services
    'services/user',
    'services/layout',
    'services/events/user-events',
    // views
    'views/parts/form/button',
    'text!templates/modules/noclient/noclient.html'
], function(
    Backbone,
    Mustache,
    // services
    User,
    LayoutState,
    UserEvents,
    // views
    VButton,
    TNoClient
) {
    var VNoClient = Backbone.View.extend({
        template: TNoClient,

        events: {
            "click .menu-mobile-link button": "onToggleMenu"
        },

        regions: {
            createNewClientButton: ".create-new-client-button",
            openTutorialButton: ".open-tutorial-button",
        },

        initialize: function() {
            this.view = {
                createNewClientButton: new VButton({
                    label: "create-first-client",
                    callback: this.onAddClientClick,
                    icon: "fa fa-plus",
                    tcClass: true,
                    class: "btn-lg",
                    context: this
                }),
                openTutorialButton: new VButton({
                    label: "go-to-tutorial",
                    icon: "",
                    url: this.getCreateMyFirstClientTutorialUrl(),
                    tcClass: false,
                    class: "btn-link",
                    target: '_system',
                    context: this
                }),
            };
        },

        render: function() {
            this.$el.empty().html(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            this.assign(this.view.createNewClientButton, this.zone.$createNewClientButton)
                .assign(this.view.openTutorialButton, this.zone.$openTutorialButton);

            return this;
        },

        getCreateMyFirstClientTutorialUrl: function() {
            if (User.get('language').toLowerCase().indexOf('fr') !== -1) {
                return 'https://intercom.help/totalcoaching/ressources-pour-coachs/pour-commencer/ajouter-mon-premier-client';
            }

            return 'https://intercom.help/totalcoaching/resources-for-trainers/getting-started/add-my-first-client';
        },

        onAddClientClick: function(e) {
            e.preventDefault();
            e.stopPropagation();
            UserEvents.onAddClientClick();
        },

        onToggleMenu: function() {
            LayoutState.toggleMenu();
        }
    });

    return VNoClient;
});

